'use strict';

var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _isObject2 = _interopRequireDefault(require("lodash/isObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function (schema) {
  // Recursively remove $
  var walk = function walk(element) {
    if ((0, _isObject2.default)(element)) {
      var output;

      if ((0, _isArray2.default)(element)) {
        output = [];
      } else if ((0, _isPlainObject2.default)(element)) {
        output = {};
      } else {
        return element;
      }

      for (var i in element) {
        if (i === '$') {
          // Don't copy over key
          continue;
        }

        output[i] = walk(element[i]);
      }

      return output;
    }

    return element;
  };

  var cleaned = walk(schema);
  return this.compile(cleaned);
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NvdXJjZS9zeXN0ZW0vcmVjb21waWxlLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJzY2hlbWEiLCJ3YWxrIiwiZWxlbWVudCIsIm91dHB1dCIsImkiLCJjbGVhbmVkIiwiY29tcGlsZSJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7QUFJQUEsT0FBT0MsT0FBUCxHQUFpQixVQUFVQyxNQUFWLEVBQW1CO0FBRW5DO0FBQ0EsTUFBSUMsT0FBTyxTQUFQQSxJQUFPLFVBQVc7QUFFckIsUUFBSyx3QkFBWUMsT0FBWixDQUFMLEVBQTZCO0FBRTVCLFVBQUlDLE1BQUo7O0FBRUEsVUFBSyx1QkFBV0QsT0FBWCxDQUFMLEVBQTRCO0FBRTNCQyxpQkFBUyxFQUFUO0FBRUEsT0FKRCxNQUlPLElBQUssNkJBQWlCRCxPQUFqQixDQUFMLEVBQWtDO0FBRXhDQyxpQkFBUyxFQUFUO0FBRUEsT0FKTSxNQUlBO0FBRU4sZUFBT0QsT0FBUDtBQUVBOztBQUVELFdBQU0sSUFBSUUsQ0FBVixJQUFlRixPQUFmLEVBQXlCO0FBRXhCLFlBQUtFLE1BQU0sR0FBWCxFQUFpQjtBQUNoQjtBQUNBO0FBQ0E7O0FBRURELGVBQVFDLENBQVIsSUFBY0gsS0FBTUMsUUFBU0UsQ0FBVCxDQUFOLENBQWQ7QUFDQTs7QUFFRCxhQUFPRCxNQUFQO0FBRUE7O0FBRUQsV0FBT0QsT0FBUDtBQUVBLEdBcENEOztBQXNDQSxNQUFJRyxVQUFVSixLQUFNRCxNQUFOLENBQWQ7QUFFQSxTQUFPLEtBQUtNLE9BQUwsQ0FBY0QsT0FBZCxDQUFQO0FBRUEsQ0E3Q0QiLCJzb3VyY2VzQ29udGVudCI6WyIndXNlIHN0cmljdCc7XG5cbmltcG9ydCBfIGZyb20gJ2xvZGFzaCc7XG5cbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24oIHNjaGVtYSApIHtcblxuXHQvLyBSZWN1cnNpdmVseSByZW1vdmUgJFxuXHRsZXQgd2FsayA9IGVsZW1lbnQgPT4ge1xuXG5cdFx0aWYgKCBfLmlzT2JqZWN0KCBlbGVtZW50ICkgKSB7XG5cblx0XHRcdGxldCBvdXRwdXQ7XG5cblx0XHRcdGlmICggXy5pc0FycmF5KCBlbGVtZW50ICkgKSB7XG5cblx0XHRcdFx0b3V0cHV0ID0gW107XG5cblx0XHRcdH0gZWxzZSBpZiAoIF8uaXNQbGFpbk9iamVjdCggZWxlbWVudCApICkge1xuXG5cdFx0XHRcdG91dHB1dCA9IHt9O1xuXG5cdFx0XHR9IGVsc2Uge1xuXG5cdFx0XHRcdHJldHVybiBlbGVtZW50O1xuXG5cdFx0XHR9XG5cblx0XHRcdGZvciAoIHZhciBpIGluIGVsZW1lbnQgKSB7XG5cblx0XHRcdFx0aWYgKCBpID09PSAnJCcgKSB7XG5cdFx0XHRcdFx0Ly8gRG9uJ3QgY29weSBvdmVyIGtleVxuXHRcdFx0XHRcdGNvbnRpbnVlO1xuXHRcdFx0XHR9XG5cblx0XHRcdFx0b3V0cHV0WyBpIF0gPSB3YWxrKCBlbGVtZW50WyBpIF0gKTtcblx0XHRcdH1cblxuXHRcdFx0cmV0dXJuIG91dHB1dDtcblxuXHRcdH1cblxuXHRcdHJldHVybiBlbGVtZW50O1xuXG5cdH07XG5cblx0bGV0IGNsZWFuZWQgPSB3YWxrKCBzY2hlbWEgKTtcblxuXHRyZXR1cm4gdGhpcy5jb21waWxlKCBjbGVhbmVkICk7XG5cbn07Il19